import "firebase/auth";
import "firebase/firestore";

import firebase from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDnw74S2vqtR-pJ2FCJ_3tsXpEMk3mSd_A",
  authDomain: "copysmith.firebaseapp.com",
  databaseURL: "https://copysmith.firebaseio.com",
  projectId: "copysmith",
  storageBucket: "copysmith.appspot.com",
  messagingSenderId: "827779021874",
  appId: "1:827779021874:web:09ceb04362967e9b70102b",
  measurementId: "G-KRKHLS0B8H",
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const firestore = firebase.firestore();
